import React, { Component } from 'react';

import OneBtnDialog from "@/Common/OneBtnDialog/OneBtnDialog"

import OldLanding from './OldLanding';
import NewLanding from './NewLanding';

import NewLanding2024 from './NewLanding2024';
import NewLanding2025 from './NewLanding2025';

// import

import axios from 'axios';
import DesignSelectPopup from '../DesignSelect/DesignSelectPopup/DesignSelectPopup';
import NewGalleryDialog from '../Gallery/NewGalleryDialog';

import { GetBaseUrl } from '@/utils/ConfigHelper'
import Maintain from '../Common/Maintain/Maintain';
import cookie from '../cookie'
import { connect } from 'react-redux'

import EventPopup from './EventPopup';
import EventPopupWindow from './EventPopupWindow'
import CopyToClipboard from 'copy-to-clipboard'

import { REDUX_ACTION } from '../Redux/action'
import { ReduxBinding } from '@/Redux/instance'
import { SetIsShowLoginDialog } from '../Interface'

import TemplateHelper from '@/utils/TemplateHelper'

import i18n from '../i18n'

import './index.scss'

class Home extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isDialogOpened: false,

            isBtnDialogOpened: false,
            dialogType: "shareSuccess",

            selectedVideoId: null,
            newTemplates: [],
            gallerys: [],
            templates: undefined,
            totalTemplateCount: 0,
            allFinishedVideosCount: 0,
            isServerCheck: false,
            startDate: undefined,
            endDate: undefined,
            description: undefined,

            isGalleryDialogOpen: false,
            isNewGalleryDialogOpen: false
        };

        this.serverStateTimeout = null
    }

    templateGroupMap = {}

    async componentDidMount() {
        this.serverStateTimeout = setTimeout(() => {
            const serverCheckPopUpOpened = cookie.GetCookie('serverCheckPopUpOpened')
            if (!serverCheckPopUpOpened) {
                axios.get(`${GetBaseUrl()}/api/system/servercheck`)
                    .then(response => {
                        let {
                            isServerCheck,
                            startDate,
                            endDate,
                            description,
                            description_en,
                        } = response.data

                        if (isServerCheck === true) {
                            startDate = new Date(startDate)
                            endDate = new Date(endDate)

                            startDate.setHours(startDate.getHours() + 9)
                            endDate.setHours(endDate.getHours() + 9)

                            startDate = `${startDate.toISOString().substr(11, 5)}`
                            endDate = `${endDate.toISOString().substr(11, 5)}`

                            if (this.props.value !== 'ko') {
                                description = description_en
                            }
                        }
                        this.setState({
                            isServerCheck,
                            startDate,
                            endDate,
                            description
                        })
                    })
                    .catch(e => {
                    })
            }
            else {
            }
        }, 1500)

        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

        await this.getVideos()
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
            this.getVideos(nextProps.value)
        }
    }

    componentWillUnmount() {
        if (this.serverStateTimeout) {
            clearTimeout(this.serverStateTimeout)
        }
    }

    isLoading = false
    getVideos = async (nextLang = null) => {
        if (this.isLoading) return

        this.isLoading = true
        const token = localStorage.getItem("token")

        // INDONESIA CODE
        let lang = nextLang ? nextLang : this.props.value
        if (lang === 'id') lang = 'en'

        const getNewTemplates = axios.post(`${GetBaseUrl()}/api/template/group-list`, { pageIndex: 0, pageItemCount: 9, lang, order: 0 });
        const getAllTemplatesCount = axios.get(`${GetBaseUrl()}/api/template/allTemplatesCount`);
        const getAllFinishedVideos = axios.get(`${GetBaseUrl()}/api/video/allFinishedVideos`);
        const getGallerys = axios.get(`${GetBaseUrl()}/api/video/gallery-video?offset=${0}&limit=${32}&country=${lang}&type=hot_1m`, { headers: { Authorization: `Bearer ${token}` } })
        const getStaffPicks = axios.get(`${GetBaseUrl()}/api/video/gallery-video?offset=${0}&limit=${10}&country=${lang}&type=staff-pick`, { headers: { Authorization: `Bearer ${token}` } })

        const [newTemplates, allTemplatesCount, allFinishedVideos, gallerys, staffPicks] = await Promise.all([getNewTemplates, getAllTemplatesCount, getAllFinishedVideos, getGallerys, getStaffPicks])

        if (newTemplates && allTemplatesCount) {
            if (Array.isArray(newTemplates.data.dataArr)) {
                newTemplates.data.dataArr.forEach(item => {
                    this.templateGroupMap[item.name] = item
                })
            }

            let idx = 0
            const existsMap = {}
            const galleryArr = []
            gallerys.data.videos.forEach((item, index) => {
                if (existsMap[item._id]) return
                existsMap[item._id] = true

                galleryArr.push(item)
                if (index % 3 === 0 && staffPicks.data.videos.length - 1 > idx) {
                    const staffPickItem = staffPicks.data.videos[idx++]

                    existsMap[staffPickItem._id] = true
                    galleryArr.push(staffPickItem)
                }
            })

            this.setState({
                templates: [
                    ...newTemplates.data.dataArr,
                ],
                newTemplates: newTemplates.data.dataArr,
                totalTemplateCount: allTemplatesCount.data,
                allFinishedVideosCount: allFinishedVideos.data.count,
                gallerys: galleryArr
            })
        }
        this.isLoading = false
    }

    onThumbnailClicked = (videoId, previouslyDragged) => async e => {
        if (previouslyDragged) {
            return;
        }
        const templates = await this.getTemplateById(videoId)

        axios.post(`${GetBaseUrl()}/api/template/inc_views`,
            { template_id: videoId }
        ).then().catch()
        this.setState({
            templates,
            isDialogOpened: true,
            selectedVideoId: videoId
        });
    };

    closeDialog = () => {
        this.setState({ isDialogOpened: false, selectedVideoId: null });
    };

    onVideoLikedButtonClicked = (selectedVideo, likedVideos) => e => {
        _onVideoLikedButtonClicked(this, selectedVideo, likedVideos);
    };

    getTemplateById = async (videoId) => {
        return _getTemplateById(videoId, this.state.templates)
    };

    changeSelectedVideo = async newlySelectedVideoId => {
        if (!this.state.templates) {
            return;
        }
        const refinedTemplates = await this.getTemplateById(newlySelectedVideoId);
        this.setState({
            templates: refinedTemplates,
            selectedVideoId: newlySelectedVideoId
        });
    };

    maintainCloseBtn = () => {
        cookie.SetCookie('serverCheckPopUpOpened', true, 30 * 60 * 1000)
        this.setState({
            isServerCheck: false
        })
    }

    handleGalleryThumbnailClicked = (videoId, previouslyDragged) => async e => {
        if (previouslyDragged) { return; }

        this.OpenGalleryDialog(videoId)
    }

    GetVideoInfo = async _id => {
        const token = localStorage.getItem("token")
        const response = await axios.get(`${GetBaseUrl()}/api/video/gallery-detail?id=${_id}`, { headers: { Authorization: `Bearer ${token}` } })

        const videoInfo = response.data
        this.setState({ videoInfo })

        const { gallerys } = this.state
        if (Array.isArray(gallerys)) {
            for (let i = 0; i < gallerys.length; i++) {
                if (gallerys[i]._id === videoInfo._id) {
                    gallerys[i].isLike = videoInfo.isLike
                    gallerys[i].comments = Array.isArray(videoInfo.comments) ? videoInfo.comments.length : 0
                    this.setState({ gallerys })
                    break
                }
            }
        }
        return videoInfo
    }

    OpenGalleryDialog = async (videoId) => {
        //   const token = localStorage.getItem("token")
        const videoInfo = await this.GetVideoInfo(videoId)
        axios.patch(`${GetBaseUrl()}/apis/videos/${videoId}/views/increase`).catch(e => console.log(e))

        try {
            // 다른 유저들이 만든 비디오 목록
            // let galleryDialogSameTemplateVideos = []
            // if (videoInfo && videoInfo.template) {
            //   const galleryInfo = await axios.get(`${GetBaseUrl()}/api/video/gallery-video?offset=${0}&limit=${16}&templateId=${videoInfo.template._id}`, { headers: { Authorization: `Bearer ${token}` } })
            //   const { videos } = galleryInfo.data
            //   galleryDialogSameTemplateVideos = videos
            // }

            axios.patch(`${GetBaseUrl()}/apis/videos/${videoId}/views/increase`).catch(e => console.log(e))
            this.setState({ isNewGalleryDialogOpen: true, galleryDialogSameTemplateVideos: [] });
        }
        catch (e) {
            console.log(e)
        }
    }

    moveOriginanlTemplate = async () => {
        if (this.state.videoInfo) {
            try {
                const res = await this.getTemplateById(this.state.videoInfo.template._id);

                if (!this.templateGroupMap[res[0].groupName]) {
                    const groupResponse = await axios.post(`${GetBaseUrl()}/api/template/group-info`, { id: this.state.videoInfo.template._id })
                    this.templateGroupMap[res[0].groupName] = groupResponse.data
                }

                this.setState({
                    originalTemplate: res[0],
                    getOriginalTemplateInfo: true,
                    isOriginalDesignDialogOpened: true
                })
            }
            catch (e) {
                console.log(e)
            }
        }
    }

    handleClickGalleryDialogReturnBtn = () => {
        const { stackedVideoIds } = this.state

        if (stackedVideoIds.length === 0) return

        const lastVideoId = stackedVideoIds[stackedVideoIds.length - 1]
        const newStackedVideoIds = stackedVideoIds.filter(id => lastVideoId !== id)
        this.setState({ stackedVideoIds: newStackedVideoIds }, () => {
            this.OpenGalleryDialog(lastVideoId)
        })
    }

    handleNewGalleryDialogClose = () => {
        this.setState({ isNewGalleryDialogOpen: false, stackedVideoIds: [] })
    }

    closeGalleryDialog = () => {
        this.setState({ isGalleryDialogOpen: false, stackedVideoIds: [] })
    }

    closeOrigianlDialog = () => this.setState({ isOriginalDesignDialogOpened: false, stackedVideoIds: [] })

    updateSelectedTemplate = async (templateId) => {
        const res = await this.getTemplateById(templateId)
        this.setState({ originalTemplate: res[0] })
    }

    clickShareItem = async method => {
        const item = this.state.videoInfo
        try {
            const response = await axios.get(`${GetBaseUrl()}/api/video/share-link?id=${item._id}`)
            if (response && response.data && response.data.result === 'success') {
                const { shareId } = response.data
                const shareLink = window.location.origin + `/share?id=${shareId}`
                const { invokeCSharpAction } = window
                const isXamarin = invokeCSharpAction
                switch (method) {
                    case 'twitter':
                    case 'facebook':
                        let targetLink = 'about:blank'
                        if (method === 'twitter') targetLink = 'https://twitter.com/intent/tweet?url=' + shareLink
                        else if (method === 'facebook') targetLink = 'https://www.facebook.com/sharer/sharer.php?u=' + shareLink

                        if (isXamarin) window.location.href = targetLink
                        else {
                            const windowRef = window.open(targetLink, '_blank')
                            if (!windowRef) this.setState({
                                isBtnDialogOpened: true,
                                dialogType: "shareLinkBlock"
                            })
                        }
                        break
                    case 'linkxamarin':
                        window.invokeCSharpAction(`method=linkshare&url=${shareLink}`)
                        break

                    case 'link':
                    default:
                        CopyToClipboard(shareLink)
                        this.setState({
                            isBtnDialogOpened: true,
                            dialogType: "shareSuccess"
                        })
                        break
                }
            }
        }
        catch (e) {
            this.setState({
                isBtnDialogOpened: true,
                dialogType: "shareFail"
            })
        }
    }

    heartClick = async (id, e) => {
        e.stopPropagation()
        const token = localStorage.getItem("token");
        const { gallerys, videoInfo } = this.state
        if (token) {
            if (Array.isArray(gallerys)) {
                try {
                    for (let i = 0; i < gallerys.length; i++) {
                        if (gallerys[i]._id === id) {
                            if (!gallerys[i].isLike) {
                                gallerys[i].isLike = true
                                gallerys[i].likeMembers++
                                if (videoInfo) {
                                    videoInfo.isLike = true
                                    videoInfo.likeMembers++
                                }
                                this.setState({ gallerys, videoInfo, date: Date.now() })
                                await axios.post(`${GetBaseUrl()}/api/video/set-like`, { id }, { headers: { Authorization: `Bearer ${token}` } });
                            }
                            else {
                                gallerys[i].isLike = false
                                gallerys[i].likeMembers--
                                if (videoInfo) {
                                    videoInfo.isLike = false
                                    videoInfo.likeMembers--
                                }
                                this.setState({ gallerys, videoInfo, date: Date.now() })
                                await axios.post(`${GetBaseUrl()}/api/video/unset-like`, { id }, { headers: { Authorization: `Bearer ${token}` } });
                            }
                            break
                        }
                    }
                }
                catch (e) {
                    this.setState({
                        dialogType: "severError",
                        isBtnDialogOpened: true
                    })
                }
            }
        } else {
            this.loginRequest()
        }
    }

    loginRequest = () => {
        SetIsShowLoginDialog(true)
    }

    handleClickHashtag = (hashtag) => {
        const nxtPath = `/gallery`

        if (!hashtag || nxtPath === window.location.pathname) return

        this.props.history.push(nxtPath, { hashtag: hashtag.replace('#', '') })
    }

    handleUpdateVideoHashTag = async (hashtagString) => {
        const { videoInfo, gallerys } = this.state

        const token = localStorage.getItem("token");
        const _id = videoInfo._id

        try {
            let hashtag = ''
            if (hashtagString === '#') {
                hashtag = ''
            }
            else {
                hashtagString.split('#').forEach((tag, idx) => {
                    if (idx > 0) {
                        hashtag += (idx === 1) ? `#${tag}` : ` #${tag}`
                    }
                })
            }

            const res = await axios.patch(
                `${GetBaseUrl()}/apis/videos/${_id}/hashtag`,
                { hashtag },
                { headers: { Authorization: `Bearer ${token}` } })

            if (res.data.message === 'success') {
                let newGallerys = gallerys.map((v, idx) => {
                    if (v._id === videoInfo._id) {
                        v.hashtag = hashtag
                    }
                    return v
                })

                this.setState({ hashtagString: '', gallerys: newGallerys }, () => {
                    const videoInfo = this.GetVideoInfo(_id)
                    this.setState({ videoInfo })
                })
            }
        }
        catch (e) {
            console.log(e)
        }
    }

    handleClickGoSeeMoreVideos = (templateId) => {
        const curTemplateId = templateId
        this.props.history.push({
            pathname: '/gallery',
            state: {
                curTemplateId
            }
        })
    }

    handleClickSameTemplate = (videoId) => {
        const { stackedVideoIds, videoInfo } = this.state
        if (!videoId || !videoInfo || videoId === videoInfo._id) return

        try {
            const newStackedVideoIds = stackedVideoIds.map(e => e)
            newStackedVideoIds.push(videoInfo._id)

            this.setState({ stackedVideoIds: newStackedVideoIds }, () => {
                this.OpenGalleryDialog(videoId)
            });
        }
        catch (e) {
            console.log(e)
            return null
        }
    }

    popupHandleCloseBtn = () => this.setState({ isBtnDialogOpened: false })


    render() {
        let {
            isDialogOpened,
            selectedVideoId,
            templates,
            newTemplates,
            gallerys,
            totalTemplateCount,
            allFinishedVideosCount,

            videoInfo,
            isOriginalDesignDialogOpened,
            originalTemplate,
            getOriginalTemplateInfo,
            date,
            galleryDialogSameTemplateVideos,
            stackedVideoIds,

            isNewGalleryDialogOpen,
        } = this.state;
        const { value: lang } = this.props

        newTemplates = TemplateHelper.GetRepresentedTemplates(newTemplates, lang)

        const { history } = this.props

//NewLanding

        return (
            <div style={{ position: "relative" }}>
                <div className='home-root-container'>
                    {
                        // lang === 'ko' ? (
                            <NewLanding2025 
                                {...this.props}
                                onThumbnailClicked={this.onThumbnailClicked}
                            />
                        // ) : lang === 'en' ? (
                        //     <NewLanding
                        //         {...this.props}
                        //         {...{
                        //             totalTemplateCount
                        //         }}
                        //         onThumbnailClicked={this.onThumbnailClicked}
                        //     />) : (
                        //     <OldLanding
                        //         {...this.props}
                        //         {...{
                        //             totalTemplateCount,
                        //             newTemplates,
                        //             allFinishedVideosCount,
                        //             gallerys
                        //         }}
                        //         handleClickHashtag={this.handleClickHashtag}
                        //         onThumbnailClicked={this.onThumbnailClicked}
                        //         handleGalleryThumbnailClicked={this.handleGalleryThumbnailClicked}
                        //     />
                        // )
                    }
                    <EventPopup
                        {...this.props}
                    />
                    <EventPopupWindow />
                </div>

                {templates && (
                    <DesignSelectPopup
                        closeDialog={this.closeDialog}
                        isDialogOpened={isDialogOpened}
                        templateGroupMap={this.templateGroupMap}
                        selectedVideo={
                            templates.filter(template => template._id === selectedVideoId)[0]
                        }
                        changeSelectedVideo={this.changeSelectedVideo}
                        onVideoLikedButtonClicked={this.onVideoLikedButtonClicked}
                        history={history}
                    />
                )}
                {/* <GalleryDialog
                    {...this.props}
                    open={this.state.isGalleryDialogOpen}
                    videoInfo={videoInfo}
                    isOriginalDesignDialogOpened={isOriginalDesignDialogOpened}
                    moveOriginanlTemplate={this.moveOriginanlTemplate}
                    templateGroupMap={this.templateGroupMap}
                    originalTemplate={originalTemplate}
                    getOriginalTemplateInfo={getOriginalTemplateInfo}
                    closeGalleryDialog={this.closeGalleryDialog}
                    closeOrigianlDialog={this.closeOrigianlDialog}
                    updateSelectedTemplate={this.updateSelectedTemplate}
                    onVideoLikedButtonClicked={this.onVideoLikedButtonClicked}
                    loginRequest={this.loginRequest}
                    clickShareItem={this.clickShareItem}
                    updateVideoInfo={this.GetVideoInfo}
                    heartClick={this.heartClick}
                    date={date}
                    onClickSameTemplate={this.handleClickSameTemplate}
                    onClickGoSeeMoreVideos={this.handleClickGoSeeMoreVideos}
                    onClickReturnBtn={this.handleClickGalleryDialogReturnBtn}
                    onClickHashTag={this.handleClickHashtag}
                    onUpdateHashTag={this.handleUpdateVideoHashTag}
                    galleryDialogSameTemplateVideos={galleryDialogSameTemplateVideos}
                    stackedVideoIds={stackedVideoIds}
                /> */}

                <NewGalleryDialog
                    {...this.props}
                    open={isNewGalleryDialogOpen}
                    onClose={this.handleNewGalleryDialogClose}
                    videoInfo={videoInfo}
                    loginRequest={this.loginRequest}
                    clickShareItem={this.clickShareItem}
                    updateVideoInfo={this.GetVideoInfo}
                    heartClick={this.heartClick}
                    moveOriginanlTemplate={this.moveOriginanlTemplate}
                    isOriginalDesignDialogOpened={isOriginalDesignDialogOpened}
                    templateGroupMap={this.templateGroupMap}
                    originalTemplate={originalTemplate}
                    getOriginalTemplateInfo={getOriginalTemplateInfo}
                    closeOrigianlDialog={this.closeOrigianlDialog}
                    updateSelectedTemplate={this.updateSelectedTemplate}
                    onClickSameTemplate={this.handleClickSameTemplate}
                    galleryDialogSameTemplateVideos={galleryDialogSameTemplateVideos}
                    onVideoLikedButtonClicked={this.onVideoLikedButtonClicked}
                    onClickGoSeeMoreVideos={this.handleClickGoSeeMoreVideos}
                    stackedVideoIds={stackedVideoIds}
                    onClickReturnBtn={this.handleClickGalleryDialogReturnBtn}
                    onClickHashTag={this.handleClickHashtag}
                    onUpdateHashTag={this.handleUpdateVideoHashTag}
                    date={date}
                />

                <Maintain
                    value={this.props.value}
                    isServerCheck={this.state.isServerCheck}
                    description={this.state.description}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    maintainCloseBtn={this.maintainCloseBtn}
                />
                <OneBtnDialog
                    dialogType={this.state.dialogType}
                    open={this.state.isBtnDialogOpened}
                    closeBtn={this.popupHandleCloseBtn}
                    onButtonClick={this.popupHandleCloseBtn}
                />
            </div>
        );
    }
}

export const _onVideoLikedButtonClicked = async (
    self,
    selectedVideo,
    likedVideos
) => {
    if (!selectedVideo || !Array.isArray(likedVideos)) return
    const { groupName } = selectedVideo

    const token = localStorage.getItem('token')
    try {
        const isLike = !likedVideos.includes(groupName)
        const newLikedTemplate = [...likedVideos]

        if (isLike) {
            newLikedTemplate.push(groupName)
            await axios.post(
                `${GetBaseUrl()}/api/user/like-template-name`,
                { name: groupName },
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            )
        }
        else {
            newLikedTemplate.splice(likedVideos.indexOf(groupName), 1)
            await axios.delete(
                `${GetBaseUrl()}/api/user/like-template-name?name=${groupName}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            )
        }
        ReduxBinding(REDUX_ACTION.LIKE_TEMPLATES, newLikedTemplate)
    }
    catch (e) {

    }
};

export const _getTemplateById = async (videoId) => {
    const result = await axios.get(`${GetBaseUrl()}/api/template/findwithoutdata/${videoId}`);
    if (result && result.data) return [result.data]
};

const mapStateToProps = state => ({
    value: state.langStore.lang,
})

export default connect(
    mapStateToProps,
    null
)(Home)